import {defineNestedRouteConfig} from '../nestedRouteUtils';
import {
  ENTITY_REGISTRY_ACCESS_CONTROL_PATH,
  ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  ENTITY_REGISTRY_DETAILS_PATH,
  ENTITY_REGISTRY_LANDING_PATH,
  OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  ORG_SCOPED_REGISTRY_PATHS,
  ORG_SCOPED_REGISTRY_SETTINGS_PATH,
} from './registryPaths';

/**
 * Route definitions for registry pages and their RUM view names.
 * Order matters — most specific paths first for correct matching.
 */
export const REGISTRY_NESTED_ROUTES = defineNestedRouteConfig({
  exact: true,
  entries: [
    {
      paths: [
        ...ENTITY_REGISTRY_ALL_TEAMS_PATHS,
        ENTITY_REGISTRY_LANDING_PATH,
        ENTITY_REGISTRY_DETAILS_PATH,
        ENTITY_REGISTRY_ACCESS_CONTROL_PATH,
      ],
      datadogViewName: 'Registries:entity',
    },
    {
      paths: [
        ...OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS,
        ...ORG_SCOPED_REGISTRY_PATHS,
        ORG_SCOPED_REGISTRY_SETTINGS_PATH,
      ],
      datadogViewName: 'Registries:org',
    },
  ],
});
